import { reactive } from "vue";

export const TABLE = reactive({
  isLoading: false,
  isReSearch: false,
  pageOptions: [
    {
      value: 10,
      text: 10,
    },
    {
      value: 15,
      text: 15,
    },
    {
      value: 25,
      text: 25,
    },
    {
      value: 50,
      text: 50,
    },
  ],
  multiPageTableColumns: {
    internacao: [
      { field: "nAih", label: "Número AIH", sortable: true },
      { field: "ufResidencia", label: "UF Residência", sortable: true },
      { field: "codigoMunicipioResidencia", label: "Muncípio Residência", sortable: true },
      { field: "dtInter", label: "Data Internação", sortable: true },
      { field: "dtSaida", label: "Data Saída", sortable: true },
      { field: "ident", label: "Tipo AIH", sortable: true },
      { field: "caraterAtendimento", label: "Tipo Atendimento", sortable: true },
      { field: "diagPrinc", label: "Diagnóstico Principal", sortable: true },
      { field: "diagSecun", label: "Diagnóstico Secundário", sortable: true },
      { field: "diagSec1", label: "Diagnóstico Secundário 1", sortable: true },
      { field: "diagSec2", label: "Diagnóstico Secundário 2", sortable: true },
      { field: "diagSec3", label: "Diagnóstico Secundário 3", sortable: true },
      { field: "diagSec4", label: "Diagnóstico Secundário 4", sortable: true },
      { field: "diagSec5", label: "Diagnóstico Secundário 5", sortable: true },
      { field: "diagSec6", label: "Diagnóstico Secundário 6", sortable: true },
      { field: "diagSec7", label: "Diagnóstico Secundário 7", sortable: true },
      { field: "diagSec8", label: "Diagnóstico Secundário 8", sortable: true },
      { field: "diagSec9", label: "Diagnóstico Secundário 9", sortable: true },
      { field: "cidMorte", label: "Causa Morte", sortable: true },
    ],
    violencias: [
      { field: "nuNotific", label: "Número Notificação", sortable: true },
      { field: "ufResidencia", label: "UF Residência", sortable: true },
      { field: "codigoMunicipioResidencia", label: "Municío Residência", sortable: true },
      { field: "sgUfOcor", label: "UF Ocorrência", sortable: true },
      { field: "idMnOcor", label: "Municío Ocorrência", sortable: true },
      { field: "dtOcor", label: "Data Violência", sortable: true },
      { field: "localOcor", label: "Local Ocorrência", sortable: true },
      { field: "outVezes", label: "Ocorreu outras vezes?", sortable: true },
      { field: "lesAutop", label: "Lesão autoprovacada?", sortable: true },
      { field: "violMotiv", label: "Violência motivo", sortable: true },
      {
        field: "tipoViolencia",
        label: "Tipo Violência",
        sortable: true,
      },
      {
        field: "meioAgressao",
        label: "Meio de agressão",
        sortable: true,
      },
      {
        field: "tipoViolenciaSexual",
        label: "Tipo Violência Sexual",
        sortable: true,
      },
      { field: "relTrab", label: "Violência Trabalho?", sortable: true },
      { field: "circLesao", label: "CID Violência", sortable: true },
      { field: "circLesaoOntologia", label: "CID Ontologias", sortable: true },
    ],
    transporte: [
      { field: "nuNotific", label: "Número Notificação", sortable: true },
      { field: "ufResidencia", label: "UF Residência", sortable: true },
      { field: "codigoMunicipioResidencia", label: "Município Residência", sortable: true },
      { field: "sgUfOcor", label: "UF Ocorrência", sortable: true },
      { field: "idMnOcor", label: "Município Ocorrência", sortable: true },
      { field: "dtOcor", label: "Data Acidente", sortable: true },
      { field: "tipVit", label: "Tipo Ví­tima", sortable: true },
      { field: "meioAcid", label: "Meio Acidente", sortable: true },
      { field: "meioAcidOutro", label: "Outro meio Acidente", sortable: true },
      { field: "natAcid", label: "Natureza Acidente", sortable: true },
      { field: "outrasNatAcid", label: "Outra Natureza", sortable: true },
      { field: "outraPartEnvol", label: "Outra Parte Envolvida", sortable: true },
      { field: "outrosEnvol", label: "Outros Envolvidos", sortable: true },
      { field: "semaforo", label: "Desrespeito ao semáforo", sortable: true },
      { field: "outroFatRelAcid", label: "Outro Fator Acidente", sortable: true },
      { field: "relTrab", label: "Acidente Trabalho?", sortable: true },
      { field: "evolucao", label: "Evolução Atendimento", sortable: true },
      { field: "natLesao", label: "Natureza Lesão", sortable: true },
      { field: "natLesaoOutro", label: "Natureza Lesão (Outro)", sortable: true },
      { field: "circLesao", label: "CID Acidente", sortable: true },
    ],
    trabalho: [
      { field: "nuNotific", label: "Número Notificação", sortable: true },
      { field: "ufResidencia", label: "UF Residência", sortable: true },
      { field: "codigoMunicipioResidencia", label: "Município Residência", sortable: true },
      { field: "sgUfOcor", label: "UF Ocorrência", sortable: true },
      { field: "idMnOcor", label: "Município Ocorrência", sortable: true },
      { field: "dtOcor", label: "Data Acidente", sortable: true },
      { field: "localAcid", label: "Local Acidente", sortable: true },
      { field: "tipoAcid", label: "Tipo Acidente", sortable: true },
      { field: "atendeMed", label: "Atendimento Médico?", sortable: true },
      { field: "regime", label: "Tratamento", sortable: true },
      { field: "evolucao", label: "Evolução", sortable: true },
      { field: "dataObito", label: "Data Óbito", sortable: true },
      { field: "cidLesao", label: "CID Lesão", sortable: true },
      { field: "circLesao", label: "CID Acidente", sortable: true },
    ],
    intoxicacoes: [
      { field: "nuNotific", label: "Número Notificação", sortable: true },
      { field: "ufResidencia", label: "UF Residência", sortable: true },
      { field: "codigoMunicipioResidencia", label: "Município Residência", sortable: true },
      { field: "sgUfOcor", label: "UF Ocorrência", sortable: true },
      { field: "idMnOcor", label: "Município Ocorrência", sortable: true },
      { field: "dtOcor", label: "Data Diagnóstico", sortable: true },
      { field: "locExpo", label: "Local Exposição", sortable: true },
      { field: "agenteTox", label: "Grupo do agente tóxico", sortable: true },
      { field: "outAgente", label: "Se outro, qual?", sortable: true },
      { field: "circunstan", label: "Circunstância da exposição", sortable: true },
      { field: "agente1", label: "Agente Tóxico 1", sortable: true },
      { field: "agente2", label: "Agente Tóxico 2", sortable: true },
      { field: "agente3", label: "Agente Tóxico 3", sortable: true },
      { field: "circunDes", label: "Outra circunstância, qual?", sortable: true },
      { field: "doencaTra", label: "Intoxicação no trabalho?", sortable: true },
      { field: "tpAtende", label: "Tipo de atendimento", sortable: true },
      { field: "hospital", label: "Hospitalização?", sortable: true },
      { field: "dtInterna", label: "Data Internação", sortable: true },
      { field: "classiFin", label: "Classificação final", sortable: true },
      { field: "evolucao", label: "Evolução do caso", sortable: true },
      { field: "dataObito", label: "Data Óbito", sortable: true },
      { field: "circLesao", label: "CID Intoxicação", sortable: true },
      { field: "circLesaoOntologia", label: "CID Ontologias", sortable: true },
    ],
  },
  columns: [
    { field: "numDO", label: "Num DO", sortable: true, isKey: true },
    { field: "sexo", label: "Sexo", sortable: true },
    { field: "idadeObito", label: "Idade", sortable: true },
    { field: "ufResidencia", label: "UF", sortable: true },
    { field: "codigoMunicipioResidencia", label: "Mun Resid", sortable: true },
    { field: "dataObito", label: "Data Óbito", sortable: true },
    { field: "acidenteTrabalho", label: "Acidente Trabalho", sortable: true },
    { field: "tipoObito", label: "Causa Externa", sortable: true },
    { field: "codigoCausaBasica", label: "Causa Básica", sortable: true },
    { field: "status", label: "Status", sortable: true },
    { field: "codigoCausaBasicaReclassificada", label: "Reclassificação", sortable: true },
    { field: "concordaReclassificacao", label: "Concorda com o Agrupamento ML?", sortable: true },
    { field: "dataRevisao", label: "Data Revisão", sortable: true },
    { field: "actions" },
  ],
  rows: [],
  totalRecordCount: 0,
  originalRows: [],
  sortable: {
    order: "numDO",
    sort: "asc",
  },
});
